import { EntDirectoryInfoName } from "../directoryInfoName";
import { EntEconomicActivityTypes } from "../handBooks/economicActivityTypes";
import { EntTerritorialsUnits } from "../handBooks/territorialsUnits";


export class EntAgroculturalCooperative{
  id: number | null = null;
  codeOkpo: string | null = null;
  name: string | null = null;
  year: string | null = null;
  legalAddressTerritorialUnit: EntTerritorialsUnits | null = null;
  legalAddressTerritorialUnitId: number | null = null;
  legalAddressZipCode: string | null = null;
  legalAddress: string | null = null;
  actualAddressTerritorialUnit: EntTerritorialsUnits | null = null;
  actualAddressTerritorialUnitId: number | null = null;
  actualAddressZipCode: string | null = null;
  actualAddress: string | null = null;
  managerFullName: string | null = null;
  email: string | null = null;
  phoneNumber: string | null = null;
  legalForm: EntDirectoryInfoName | null = null;
  legalFormId: number | null = null;
  typeEconomicActivity: EntEconomicActivityTypes | null = null;
  typeEconomicActivityId: number | null = null;
  longitude: number | undefined = undefined;
  latitude: number | undefined = undefined;

  legalRegionId: number | null = null;
  legalAreaId: number | null = null;

  legalAddressTerritorialUnitRegion: EntTerritorialsUnits | null = null;
  legalAddressTerritorialUnitArea: EntTerritorialsUnits | null = null;

  actualRegionId: number | null = null;
  actualAreaId: number | null = null;

  actualAddressTerritorialUnitRegion: EntTerritorialsUnits | null = null;
  actualAddressTerritorialUnitArea: EntTerritorialsUnits | null = null;

}
